<template>
  <div class="sc-slots-mode" :class="'sc-slots-' + mode">
    <div class="sc-slots-title">
      <img v-if="icon" class="sc-slots-icon" :src="icon" alt="" />
      <span v-else class="sc-dot" :class="'sc-dot-' + mode"></span>
      <span v-html="title"></span>
    </div>
    <div v-if="enabled && availableHours.length" class="sc-slots-grid">
      <button
        v-for="hour in availableHours"
        :key="hour"
        type="button"
        class="sc-slot"
        :class="{ 'is-selected': hour === selected }"
        :aria-pressed="hour === selected ? 'true' : 'false'"
        @click="$emit('select', hour)"
      >
        {{ hour }}h
      </button>
    </div>
    <p v-else class="sc-slots-empty">{{ emptyMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "SlotPicker",
  props: {
    mode: { type: String, required: true }, // "retrait" | "livraison"
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
    hours: { type: Array, default: () => [] },
    available: { type: Array, default: () => [] },
    selected: { type: String, default: null },
    enabled: { type: Boolean, default: true },
    emptyMessage: { type: String, default: "" },
  },
  computed: {
    // ne garde que les créneaux ouverts, dans l'ordre de la journée
    availableHours() {
      const available = this.available.map(String);
      return this.hours.filter((hour) => available.indexOf(hour) !== -1);
    },
  },
};
</script>
